export const GET_EVENT_REASONS = 'GET_EVENT_REASONS';
export const GET_EVENT_REASON_BY_ID = 'GET_EVENT_REASON_BY_ID';
export const UPDATE_EVENT_REASON = 'UPDATE_EVENT_REASON';
export const DELETE_EVENT_REASON = 'DELETE_EVENT_REASON';
export const CREATE_EVENT_REASON = 'CREATE_EVENT_REASON';
